import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { fontConverterMap } from './fontPropsToCss'

/**
 * Enriches the converters registry with all font-related style property converters.
 * Font converters handle font types, styles, weights, and other typography properties.
 */
export function enrichFontConverters(): void {
	// Register all font converters
	Object.entries(fontConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
